<template>
  <div class="mb-6">
    <v-row dense>
      <v-col cols="4">
        <base-input-select
          v-model="form.day"
          :label="$t('fields.day')"
          :items="dayList"
          outlined
          solo
          hide-details
          background-color="white"
        ></base-input-select>
      </v-col>
      <v-col cols="4">
        <base-input-select
          v-model="form.month"
          :label="$t('fields.month')"
          :items="monthList"
          outlined
          solo
          hide-details
          background-color="white"
        ></base-input-select>
      </v-col>
      <v-col cols="4">
        <base-input-select
          v-model="form.year"
          :label="$t('fields.year')"
          :items="yearList"
          outlined
          solo
          hide-details
          background-color="white"
        ></base-input-select>
      </v-col>
    </v-row>
    <p
      v-if="error"
      class="pink-berry--text pa-0 ma-0 ml-3 mt-1 mb-2"
      style="font-size: 12px"
    >
      {{ $t('productDetailPage.individualProduct.dateField') }}
    </p>
    <base-button
      v-if="shouldShowDeleteButton"
      outlined
      block
      small
      rounded
      class="mt-4"
      @click="clear"
      >{{ $t('commons.deleteDate') }}</base-button
    >
  </div>
</template>

<script>
import BaseInputSelect from '~/components/base/input/BaseInputSelect'
import BaseButton from '~/components/base/button/BaseButton'

export default {
  name: 'ProductIndividualisationFieldDate',
  components: { BaseButton, BaseInputSelect },
  props: {
    value: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      error: false,
      form: {
        day: '',
        month: '',
        year: '',
      },
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    shouldShowDeleteButton() {
      return this.form.year || this.form.month || this.form.day
    },
    dayList() {
      return Array.from(Array(31).keys()).map((i) => i + 1)
    },
    monthList() {
      return Array.from(Array(12).keys()).map((i) => i + 1)
    },
    yearList() {
      const currentYear = new Date().getFullYear()
      return Array.from(Array(110).keys()).map((i) => currentYear - i)
    },
  },
  watch: {
    form: {
      handler() {
        this.internalValue = this.getInput()
      },
      deep: true,
    },
  },
  methods: {
    getInput() {
      if (!this.form.year && !this.form.month && !this.form.day) {
        this.error = false

        return ''
      } else if (!this.form.year || !this.form.month || !this.form.day) {
        this.error = true

        return ''
      } else {
        this.error = false

        const m = String(this.form.month)?.padStart(2, '0')
        const d = String(this.form.day)?.padStart(2, '0')

        return `${this.form.year}-${m}-${d}`
      }
    },
    clear() {
      this.form = {
        day: '',
        month: '',
        year: '',
      }
    },
  },
}
</script>
